export const formatColumnNames = (name) => {
    name = name.replace("provider", "vendor")
    return name.split("_").join(" ");
}

export const createdUpdatedAtValueFormat = (value) => {
    return value.replace("T", " ").split(".000000Z")[0];
}